import type { Client } from "@fartherfinance/frontend/api/Entity/requests/getAdvisorClients";

import { HouseholdTableProps } from "../Households/types";
import { CheckboxListConfig } from "@src/sharedComponents/ScrollableCheckboxList/ScrollableCheckboxList";

export const TableKeys = [
  "Name",
  "Household",
  "Email",
  "Mobile",
  "ID",
  "Advisor",
  "Created",
  "Login",
] as const;

export type TableKeysType = typeof TableKeys[number];

type ClientTableKeys = Exclude<TableKeysType, "ID" | "Login">;

export type ClientSearchFiltersCheckboxLabel = ClientTableKeys | "Client ID"; // "Client ID" replaces ID from TableKeys

export interface ClientWithAdvisorName extends Client {
  advisorName: {
    first: string;
    last: string;
  };
}

export interface ClientsTableProps extends HouseholdTableProps {
  searchFilters: CheckboxListConfig<ClientSearchFiltersCheckboxLabel>;
}
